import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/PageHeader';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/EmptyState';
import { Bell, CheckCircle2 } from 'lucide-react';
import { fmtRelative, fmtDateTime } from '@/lib/dates';
import { cn } from '@/lib/utils';

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = () => {
    setLoading(true);
    api.get('/notifications').then((r) => { setItems(r.data.items); setUnread(r.data.unread); }).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const markAll = async () => {
    await api.post('/notifications/read-all');
    load();
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Notifikasi"
        subtitle={`Anda memiliki ${unread} notifikasi belum dibaca.`}
        action={unread > 0 && <Button variant="outline" onClick={markAll}><CheckCircle2 className="w-4 h-4 mr-2" />Tandai semua dibaca</Button>}
      />

      <Card className="border-slate-200 shadow-premium">
        <CardContent className="p-0">
          {loading ? (
            <div className="py-16 flex justify-center"><div className="animate-spin w-6 h-6 border-2 border-red-600 border-t-transparent rounded-full" /></div>
          ) : items.length === 0 ? (
            <div className="py-12"><EmptyState title="Belum ada notifikasi" icon={Bell} /></div>
          ) : (
            <div className="divide-y divide-slate-100">
              {items.map((n) => (
                <button
                  key={n.id}
                  onClick={async () => { if (!n.is_read) { await api.post(`/notifications/${n.id}/read`); load(); } if (n.link) navigate(n.link); }}
                  className={cn('w-full text-left p-4 hover:bg-slate-50 flex items-start gap-3', !n.is_read && 'bg-red-50/30')}
                >
                  <span className={cn('mt-1.5 w-2.5 h-2.5 rounded-full flex-shrink-0', !n.is_read ? 'bg-red-600' : 'bg-slate-300')} />
                  <div className="flex-1">
                    <div className="font-semibold text-slate-800">{n.title}</div>
                    <div className="text-sm text-slate-600 mt-0.5">{n.message}</div>
                    <div className="text-xs text-slate-400 mt-1">{fmtRelative(n.created_at)} · {fmtDateTime(n.created_at)}</div>
                  </div>
                  <span className="text-[10px] uppercase font-bold px-2 py-1 rounded bg-slate-100 text-slate-600">{n.category}</span>
                </button>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
